import React from 'react';
import { Checkbox, Link, Row, Text } from 'library/ui';

export default function ConsentCheckbox({
    consent,
    setConsent,
}: {
    consent: boolean;
    setConsent: (b: boolean) => void;
}) {
    return (
        <Row gap="sm">
            <Checkbox id="signup-consent-checkbox" checked={consent} onChange={onValueChanged} />
            <Text size="xs" tone="secondary">
                By signing up, I agree to Tandem&apos;s{' '}
                <Link to="/tandem-terms-of-use/center" size="sm">
                    Terms of Use
                </Link>{' '}
                and{' '}
                <Link to="/privacy-policy" size="sm">
                    Privacy Policy.
                </Link>
            </Text>
        </Row>
    );

    function onValueChanged(isChecked: boolean) {
        setConsent(isChecked);
    }
}
